<template>
  <ontos-form-dialog v-bind="heading" max-width="800px"
                     :saving="saving" :save-disabled="!changed || !valid" :dirty="changed"
                     @save="$emit('save', draft)" @closed="$emit('closed')">
    <ontos-access-input :value="draft" :idea="idea" :workspace="workspace"
                        @input="draft = $event" @validity="valid = $event"/>
  </ontos-form-dialog>
</template>
<script lang="ts">
import {Component, Vue, Prop, toNative} from 'vue-facing-decorator'
import AccessInput from '@/components/design/class/AccessInput.vue'
import Idea, {IdeaAccess, writtenAccess} from '@/types/Idea'
import {EnhancedWorkpace} from '@/types/Workspace'
import {deepCopy} from '@/utils/copy'
import {deepStructuredDiff} from '@/utils/modelUtils'
import {Heading, collectionAccess} from '@/utils/heading'

/**
 * As permissões da coleção, editadas a partir da seção delas na visualização (pedido do usuário),
 * e não no meio do editar coleção: são da coleção inteira, como o fluxo, e têm a sua parte na tela.
 *
 * Emite o acesso INTEIRO — o servidor grava o acesso todo de uma vez. Quem persiste é o host.
 */
@Component({emits: ['closed', 'save'],
  name: 'ontos-access-dialog',
  components: {'ontos-access-input': AccessInput}
})
class AccessDialog extends Vue {
  @Prop({type: Object, required: true}) readonly idea!: Idea
  @Prop({required: true}) readonly workspace!: EnhancedWorkpace
  @Prop({type: Boolean, default: false}) readonly saving!: boolean

  draft: IdeaAccess = {}
  valid = true

  /** No created, e não no inicializador do campo — ver o mesmo comentário no `ClassDialog`. */
  created() {
    this.draft = deepCopy(this.idea.access || {})
  }

  get heading(): Heading {
    return collectionAccess(this.idea)
  }

  get changed(): boolean {
    return Object.keys(deepStructuredDiff(writtenAccess(this.idea.access), writtenAccess(this.draft))).length > 0
  }
}

export default toNative(AccessDialog)
</script>
